import { Fragment, memo, useCallback, useEffect } from "react";
import { ReactComponent as LogoFullIcon } from "components/icons/logo_full.svg";
import { AdUnitsKeys, units } from "./config/units";
import classes from "./AdUnit.module.scss";
import { deviceTypeEnum, useDeviceType } from "hooks/useDeviceType";
import { isDisableAds } from "./utils";

const RETRY_LIMIT = 5;
const TIMEOUT = 1000;

export enum AdUnitTypeEnum {
  MOBILE="Mobile",
  DESKTOP="Desktop"
}

interface AdUnitProps {
  name: AdUnitsKeys;
  type: AdUnitTypeEnum;
}

const AdUnit = memo(({ name, type }: AdUnitProps) => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  const code = units[name];
  const id = code.display ?? `sp_${code.sid}`;

  const addCode = useCallback((iteration: number) => {
    if (iteration > RETRY_LIMIT) {
      return;
    }

    if (!window?.goCtrl?.add) {
      console.debug("[ads] goCtrl instance not found");
      setTimeout(() => {
        addCode(iteration + 1);
      }, TIMEOUT);
      return;
    }

    const { style, ...goCtrlCode } = code;
    goCtrlCode.display = id;

    console.debug("[ads] goCtrl is ready.");

    window.goCtrl.add(goCtrlCode);
  }, [code, id]);

  useEffect(() => {
    if (isDisableAds()) {
      return;
    }

    addCode(0);
  }, [addCode]);

  const width = code.style?.width || "100%";
  const height = code.style?.height || "100%";

  return (
    <Fragment>
      { ((isDesktop && type === AdUnitTypeEnum.DESKTOP) || (!isDesktop && type === AdUnitTypeEnum.MOBILE)) && (
        <div className={classes.advertWrapper} style={code.style}>
          {
            isDisableAds() ? (
              <div className={classes.placeholder}>
                <div className={classes.background}/>
                <div
                  className={classes.content}
                  style={{
                    transform: width >= height ? "" : "rotate(90deg)",
                    width: width >= height ? width : height,
                    height: width >= height ? height : width,
                    marginLeft: width >= height ? 0 : width,
                  }}
                >
                  <div><LogoFullIcon/></div>
                  <div>advertisement: {name}</div>
                  <div>id: {code.sid}</div>
                </div>
              </div>
            ) : null
          }
          <div className={classes.advert} id={id} />
        </div>
      )}
    </Fragment>
  );
});

export default AdUnit;
